// Sports
import cricketImg from '../assets/images/home/cricket.png';
import footballImg from '../assets/images/home/football.png';
import tennisImg from '../assets/images/home/tennis.png';
import horseRacing from '../assets/images/home/horse_racing.webp';

// Home Page Web banners
import Banner2 from '../assets/images/banners/banner2.png';
import Banner3 from '../assets/images/banners/banner3.png';
import Banner4 from '../assets/images/banners/banner4.png';
import Banner5 from '../assets/images/banners/banner5.png';
import CasinoBanner1 from '../assets/images/banners/casino/banner2.png';

// Home Page Mobile banners
import MobBanner1 from '../assets/images/banners/mob_banner1.png';
import MobBanner2 from '../assets/images/banners/mob_banner2.png';
import MobBanner3 from '../assets/images/banners/mob_banner3.png';
import MobBanner4 from '../assets/images/banners/mob_banner4.png';
import MobCaisnoBanner1 from '../assets/images/banners/casino/mobile_banner2.png';

import PokerCardImg from '../assets/images/casino/cards/poker-card.png';
import EvolutionCardImg from '../assets/images/casino/cards/playing-card.png';
import RoyalCardImg from '../assets/images/casino/cards/royal-card.png';
import SuperSpadeCardImg from '../assets/images/casino/cards/jackpot-card.png';
import EzugiCardImg from '../assets/images/casino/cards/spider-card.png';

import CricketIcon from '../assets/images/home/tiles/cricket-icon.svg';
import TennisIcon from '../assets/images/home/tiles/tennis-icon.svg';
import FootballIcon from '../assets/images/home/tiles/football-icon.svg';
import TableTennisIcon from '../assets/images/home/tiles/tabletennis-icon.svg';
import EGamesIcon from '../assets/images/home/tiles/egames-icon.svg';
import RugbyIcon from '../assets/images/home/tiles/rugby-icon.svg';
import BoxingIcon from '../assets/images/home/tiles/boxing-icon.svg';
import BasketBallIcon from '../assets/images/home/tiles/basketball-icon.svg';
import BadmintonIcon from '../assets/images/home/tiles/badminton-icon.svg';
import CyclingIcon from '../assets/images/home/tiles/cycling-icon.svg';
import HorseRacingIcon from '../assets/images/home/tiles/horseracing-icon.svg';
import ChessIcon from '../assets/images/home/tiles/chess-icon.svg';
import SnookerIcon from '../assets/images/home/tiles/snooker-icon.svg';
import DartIcon from '../assets/images/home/tiles/dart-icon.svg';

import InplayEventBanner from '../assets/images/sportsbook/banners/inplay-banner.png';
import CricketEventBanner from '../assets/images/sportsbook/banners/cricket-banner.png';
import HorseRaceEventBanner from '../assets/images/sportsbook/banners/horse_racing_banner.webp';
import SoccerEventBanner from '../assets/images/sportsbook/banners/soccer-banner.png';
import TennisEventBanner from '../assets/images/sportsbook/banners/tennis-banner.png';
import BinaryEventBanner from '../assets/images/sportsbook/banners/binary-banner.png';
import IplEventBanner from '../assets/images/sportsbook/banners/ipl-banner.png';
import { WORLD_CUP } from './IPLEvent';
import { CONFIG_PERMISSIONS } from './ConfigPermission';
import cricketBannerWeb from '../assets/images/banners/casino/cricketBanner.png';
import cricketBannerMob from '../assets/images/banners/casino/mobBanner.png';

// WEB Carousel Images
const HOME_PAGE_WEB_BANNERS = [
  {
    image: 'https://cdn.hypex.one/kia/aviator.webp',
    text: 'AVIATOR',
    url: `/dc/gamev1.1/aviator-NTI1MDAx-Q1JBU0g4OC1DQVYxMDEtVlI=-Q1JBU0g4OA==-Q1JBU0g4OCBHYW1pbmc=`,
    configPermission: CONFIG_PERMISSIONS.live_casino,
  },
  {
    image: 'https://cdn.hypex.one/hypex/banner1.png',
    text: 'WORLD_CUP 2021',
    url: `/exchange_sports/cricket/indian-premier-league/winner/${btoa(
      WORLD_CUP.routeHash
    )}`,
    configPermission: CONFIG_PERMISSIONS.sports,
  },
  {
    image: 'https://cdn.hypex.one/kia/banner5.png',
    text: 'Live Casino',
    url: '/casino',
    configPermission: CONFIG_PERMISSIONS.live_casino,
  },
  {
    image: 'https://cdn.hypex.one/hypex/banner2.png',
    text: 'WORLD_CUP 2021',
    url: `/exchange_sports/cricket/indian-premier-league/winner/${btoa(
      WORLD_CUP.routeHash
    )}`,
    configPermission: CONFIG_PERMISSIONS.sports,
  },
  {
    image: 'https://cdn.hypex.one/hypex/banner3.png',
    text: 'Sports',
    url: '/virtual_sports',
    configPermission: CONFIG_PERMISSIONS.sports,
  },
  {
    image: 'https://cdn.hypex.one/hypex/banner4.png',
    text: 'Sports',
    url: '/exchange_sports/cricket',
    configPermission: CONFIG_PERMISSIONS.sports,
  },
  // {
  //   image: cricketBannerWeb,
  //   text: 'Virtual Cricket',
  //   url: '/virtual_sports',
  //   configPermission: CONFIG_PERMISSIONS.sports,
  // },
  // {
  //   image: Banner5, // Virual sports
  //   text: 'Sports',
  //   url: '/virtual_sports',
  //   configPermission: CONFIG_PERMISSIONS.sports,
  // },
  // {
  //   image: CasinoBanner1,
  //   text: 'Live Casino',
  //   url: '/casino',
  //   configPermission: CONFIG_PERMISSIONS.live_casino,
  // },
];

// Mobile Carousel Images
const HOME_PAGE_MOB_BANNERS = [
  {
    image: 'https://cdn.hypex.one/hypex/mob_banner1.png',
    text: 'WORLD_CUP 2021',
    url: `/exchange_sports/cricket/indian-premier-league/winner/${btoa(
      WORLD_CUP.routeHash
    )}`,
    configPermission: CONFIG_PERMISSIONS.sports,
  },
  {
    image: 'https://cdn.hypex.one/hypex/mob_banner2.png',
    text: 'WORLD_CUP 2021',
    url: `/exchange_sports/cricket/indian-premier-league/winner/${btoa(
      WORLD_CUP.routeHash
    )}`,
    configPermission: CONFIG_PERMISSIONS.sports,
  },
  {
    image: 'https://cdn.hypex.one/hypex/mob_banner3.png',
    text: 'Sports',
    url: '/virtual_sports',
    configPermission: CONFIG_PERMISSIONS.sports,
  },
  {
    image: 'https://cdn.hypex.one/hypex/mob_banner4.png',
    text: 'Sports',
    url: '/home',
    configPermission: CONFIG_PERMISSIONS.sports,
  },
  {
    image: MobCaisnoBanner1,
    text: 'Live Casino',
    url: '/casino',
    configPermission: CONFIG_PERMISSIONS.live_casino,
  },
  // {
  //   image: cricketBannerMob,
  //   text: 'Virtual Cricket',
  //   url: '/virtual_sports',
  //   configPermission: CONFIG_PERMISSIONS.live_casino,
  // },
];

const HOME_PAGE_HEADERS = {
  liveGames: 'Our Live Casinos',
  sportsBook: 'Sports',
  tvGames: 'TV Games',
  games: 'Games',
  casinoCards: 'Providers',
};

const HOME_PAGE_CASINO_TILES = [
  {
    image: EvolutionCardImg,
    text: 'Playing Cards',
    Provider:'Evolution Gaming'
  },
  {
    image: EzugiCardImg,
    text: 'Ezugi',
    Provider:'Ezugi'
  },
  {
    image: PokerCardImg,
    text: 'Poker',
    Provider: 'Asia Gaming'
  },
];

const HOME_PAGE_TV_GAMES = [
  {
    image: 'https://cdn.hub88.io/betgamestv/bgt_lucky7.jpg',
    id: '201149:bgt_lucky7:DC:BetGames.TV',
    text: 'Lucky 7',
  },
  {
    image: 'https://cdn.hub88.io/betgamestv/bgt_diceduel.jpg',
    id: '201150:bgt_diceduel:DC:BetGames.TV',
    text: 'Dice Duel',
  },
  {
    image: 'https://cdn.hub88.io/betgamestv/bgt_poker6.jpg',
    id: '201151:bgt_poker6:DC:BetGames.TV',
    text: 'Poker 6+',
  },
  {
    image: 'https://cdn.hub88.io/betgamestv/bgt_warofbets.jpg',
    id: '201152:bgt_warofbets":DC:BetGames.TV',
    text: 'War Of Bets',
  },
  {
    image: 'https://cdn.hub88.io/betgamestv/bgt_wheeloffortune.jpg',
    id: '201153:bgt_wheeloffortune":DC:BetGames.TV',
    text: 'Wheel Of Fortune',
  },
  {
    image: 'https://cdn.hub88.io/betgamestv/bgt_speedy7.jpg',
    id: '201158:bgt_speedy7:DC:BetGames.TV',
    text: 'Speedy 7',
  },
  {
    image:
      'https://cdn.dreamcasino.live/betgamestv/bgt_rockpaperscissors-thumb.jpg',
    id: '201159:bgt_rockpaperscissors:BetGames.TV',
    text: 'Rock Paper Scissors',
  },
  {
    image: 'https://cdn.hub88.io/betgamestv/bgt_bet-on-poker.jpg',
    id: '201157:bgt_bet-on-poker:BetGames.TV',
    text: 'Bet On Poker',
  },
];

const HOME_PAGE_GAMES = [
  {
    image: CricketIcon,
    text: 'Cricket',
    langKey:'cricket',
    id: 4,
    url: '/exchange_sports/cricket',
  },
  {
    image: TennisIcon,
    text: 'Tennis',
    langKey:'tennis',
    id: 2,
    url: '/exchange_sports/tennis',
  },
  {
    image: FootballIcon,
    text: 'Football',
    langKey:'football',
    id: 1,
    url: '/exchange_sports/football',
  },
  {
    image: TableTennisIcon,
    text: 'Table Tennis',
    langKey:'table_tennis',
    id: 4,
    url: '/home',
  },
  {
    image: EGamesIcon,
    text: 'E Games',
    langKey:'e_games',
    id: 4,
    url: '/home',
  },
  {
    image: RugbyIcon,
    text: 'Rugby League',
    langKey:'rugby_league',
    id: 4,
    url: '/home',
  },
  {
    image: BoxingIcon,
    text: 'Boxing',
    langKey:'boxing',
    id: 4,
    url: '/home',
  },
  {
    image: BasketBallIcon,
    text: 'Basketball',
    langKey:'basketball',
    id: 4,
    url: '/home',
  },
  {
    image: BadmintonIcon,
    text: 'Badminton',
    langKey:'badminton',
    id: 4,
    url: '/home',
  },
  {
    image: CyclingIcon,
    text: 'Cycling',
    langKey:'cycling',
    id: 4,
    url: '/home',
  },
  {
    image: HorseRacingIcon,
    text: 'Horse Racing',
    langKey:'horse_racing',
    id: 4,
    url: '/home',
  },
  {
    image: ChessIcon,
    text: 'Chess',
    langKey:'chess',
    id: 4,
    url: '/home',
  },
  {
    image: SnookerIcon,
    text: 'Snooker',
    langKey:'snooker',
    id: 4,
    url: '/home',
  },
  {
    image: DartIcon,
    text: 'Darts',
    langKey:'darts',
    id: 4,
    url: '/home',
  },
];

const HOME_PAGE_IMAGES = {
  poker: {
    image:
      'https://cdn.hypex.one/gap_casino/lucky7_228001.png',
    id: '100066:ezg_lucky7:EZUGI',
    text: 'Lucky 7',
  },
  blackjack: {
    image: 'https://cdn.hub88.io/evolution/evo_liveblackjackd.jpg',
    id: '200163:evo_speed_blackjack_d:DC:Evolution Gaming',
    text: 'Blackjack D', //
  },
  baccarat: {
    image:
      'https://cdn.hypex.one/gap_casino/no_commission_baccarat_170.png',
    id: '100060:ezg_nocommissionbaccarat:EZUGI:EZUGI',
    text: 'No Comm Baccarat',
    url: '/casino/live-baccarat',
  },
  roulette: {
    image:
      'https://cdn.hypex.one/gap_casino/ezg_ultimate_roulette1.jpg',
    id: '100082:ezg_ultimate_roulette:EZUGI:Ezugi',
    text: 'Ultimate Roulette',
  },
  vip_roulette: {
    image: 'https://cdn.hub88.io/evolution/evo_liveviproulette.jpg',
    id: '200196:evo_vip_roulette":DC:Evolution Gaming',
    text: 'VIP Roulette', //
  },
  dream_catcher: {
    image: 'https://cdn.hub88.io/evolution/evo_livedreamcatcher.jpg',
    id: '200211:evo_dream_catcher":DC:Evolution Gaming',
    text: 'Dream Catcher', //
  },
  andarBahar: {
    image:
      'https://cdn.hypex.one/gap_casino/andar_bahar_228000.png',
    id: '100063:ezg_andarbaharlobby:EZUGI:EZUGI',
    text: 'Andar Bahar',
  },
  teenpatti: {
    image:
      'https://cdn.hypex.one/gap_casino/teen_patti_227100.png',
    id: '100046:ezg_teenpatti:EZUGI:EZUGI',
    text: 'Teen Patti',
  },
  cricket: {
    image: cricketImg,
    text: 'Cricket',
    url: '/exchange_sports/cricket',
  },
  football: {
    image: footballImg,
    text: 'Football',
    url: '/exchange_sports/football',
  },
  tennis: {
    image: tennisImg,
    text: 'Tennis',
    url: '/exchange_sports/tennis',
  },
  horseracing: {
    image: horseRacing,
    text: 'Horse Racing',
    url: '/exchange_sports/horseracing',
  },
};

const EVENT_PAGE_IMAGES = {
  cricket: {
    image: CricketEventBanner,
    text: 'Cricket',
    url: '/exchange_sports/cricket',
  },
  football: {
    image: SoccerEventBanner,
    text: 'Football',
    url: '/exchange_sports/football',
  },
  tennis: {
    image: TennisEventBanner,
    text: 'Tennis',
    url: '/exchange_sports/tennis',
  },
  horseracing: {
    image: HorseRaceEventBanner,
    text: 'horseracing',
    url: '/exchange_sports/horseracing',
  },
  inplay: {
    image: InplayEventBanner,
    text: 'In Play',
    url: '/exchange_sports/inplay',
  },
  ipl: {
    image: IplEventBanner,
    text: 'WORLD_CUP',
    url: `/exchange_sports/cricket/indian-premier-league/winner/${btoa(
      WORLD_CUP.routeHash
    )}`,
  },
  // binary: {
  //   image: BinaryEventBanner,
  //   text: 'Binary',
  //   url: '/exchange_sports/binary',
  // },
};

export default {
  HOME_PAGE_HEADERS,
  HOME_PAGE_IMAGES,
  HOME_PAGE_WEB_BANNERS,
  HOME_PAGE_MOB_BANNERS,
  HOME_PAGE_CASINO_TILES,
  HOME_PAGE_GAMES,
  HOME_PAGE_TV_GAMES,
  EVENT_PAGE_IMAGES,
};
